import React from 'react';
import classNames from 'classnames';
import './index.less';

export interface IABSParagraphProps {
  className?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  hasMarginBottom?: boolean; 
}
 
class ABSParagraph extends React.Component<IABSParagraphProps> {
  render() {
    const { className, children, style, hasMarginBottom } = this.props;
    const classes = classNames('abs-paragraph', { 'abs-paragraph-gap'  : hasMarginBottom}, className);
    if (typeof children === 'string') {
      return (
        <p className={classes} dangerouslySetInnerHTML={{__html: children }} style={style} />
      );
    }
    return (
      <div className={classes} style={style}>{children}</div>
    );
  }
}
 
export default ABSParagraph;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSParagraph/index.tsx